import React from 'react';


export default function BluredSection({show}){
    return (
        show 
        ? <div className='blured-section'></div> 
        : null
    )
}